import React, { Component, PropTypes } from 'react';
import { VictoryChart, VictoryLine, VictoryScatter, VictoryAxis } from 'victory';

import {
  Card,
  CardActions,
  CardText,
  CardTitle,
  DatePicker,
  FlatButton,
  IconButton,
  List,
  ListItem,
  Paper,
  RaisedButton,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TextField,
} from 'material-ui';

import {HotKeys} from 'react-hotkeys';

import math from 'mathjs';

export default class Account extends Component {
  constructor(props){
    super(props);
    this.state = {
      name: null,
    }
  }

  componentDidMount(){
  }

  componentWillUnmount(){
  }

  save(){
    // this.props.update({note, attrs});
  }

  delete(){
    this.props.update({deleted_at: +new Date()})
  }

  renderName(){
    const account = this.props.account;
    return (
      <h1 style={{display: 'flex', alignItems: 'center'}}>
        <form
          style={{flex: 1, display: 'flex'}}
          onSubmit={(e) => {e.preventDefault(); this.refs.nameInput.blur(); this.props.update({name: this.state.name}); this.setState({name: null})}}
        >
          <TextField
            ref="nameInput"
            name={"account_name"}
            // fullWidth={true}
            style={{
              fontSize: "40px",
              flex: 1,
            }}
            onBlur={() => {if(this.state.name) this.props.update({name: this.state.name}); this.setState({name: null})}}
            onChange={(e, name) => this.setState({name})}
            value={this.state.name || account.name}
          />
        </form>

        <FlatButton
          label="delete"
          secondary={true}
          style={{float: "right"}}
          onTouchTap={this.delete.bind(this)}
        />
      </h1>
    )
  }

  render(){
    const firebaseRef = this.props.firebaseRef;
    const account = this.props.account;

    if(!account) return <div></div>;

    const keyHandlers = {
      // save: (e) => {
      //   e.preventDefault();
      //   this.save();
      // }
    }

    account.records || (account.records = {});
    let total = 0;
    let lastBalance = 0;
    const records = Object.keys(account.records)
    .map(k => {return {...account.records[k], id: k}})
    .sort((a,b) => a.date - b.date)
    .map(r => {
      const record = {...r};

      try{     record.balanceFloat = math.eval(record.balance)}
      catch(e){record.balanceFloat = parseFloat(record.balance)}

      try{     record.contributionFloat = math.eval(record.contribution)}
      catch(e){record.contributionFloat = parseFloat(record.contribution)}

      if(record.balance) lastBalance = record.balanceFloat;
      if(record.contribution) total += record.contributionFloat;
      let returnAmount  = lastBalance - total;
      let returnPercent = (lastBalance / total - 1) * 100;
      returnPercent = Math.floor(returnPercent * 100) / 100;
      return {...record, total, returnPercent, returnAmount};
    }).reverse();

    console.table(records);

    return (
      <div style={{flex: 3, paddingLeft: 20}}>
        <HotKeys handlers={keyHandlers}>
          {this.renderName()}
          <div style={{width: "50%"}}>
            {records.length > 0 && <VictoryChart>
              <VictoryLine
                data={records.filter(r => r.total)}
                style={{ data: { stroke: "blue" }}}
                x={(datum) => datum.date}
                y={(datum) => datum.total}
                label="Cont."
              />
              <VictoryLine
                data={records.filter(r => r.balance)}
                style={{ data: { stroke: "green" }}}
                x={(datum) => datum.date}
                y={(datum) => datum.balanceFloat}
                label="Bal."
              />
              <VictoryAxis tickFormat={tick => {
                const d = new Date(tick);
                return `${d.getFullYear()}-${d.getMonth()}-${d.getDay()}`
              }} />
              <VictoryAxis dependentAxis/>
            </VictoryChart>}
          </div>

          <Paper style={{padding: 10, marginRight: 10, flex: 1}} zDepth={1}>
            <h3>Contributions</h3>
            <Table selectable={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow selectable={false}>
                  <TableHeaderColumn>Date</TableHeaderColumn>
                  <TableHeaderColumn>Contribution ($)</TableHeaderColumn>
                  <TableHeaderColumn>Balance ($)</TableHeaderColumn>
                  <TableHeaderColumn>Total ($)</TableHeaderColumn>
                  <TableHeaderColumn>Return ($)</TableHeaderColumn>
                  <TableHeaderColumn>
                    <IconButton
                      iconClassName="material-icons"
                      onTouchTap={() => {
                        const records = {...account.records};
                        const now = new Date();
                        records[+now] = {date: +now};
                        this.props.update({records});
                      }}
                    >
                      playlist_add
                    </IconButton>
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {records.map(record =>
                  <TableRow key={record.id}>
                    <TableRowColumn>
                      <DatePicker
                        name={`${record.id}-date`}
                        autoOk={true}
                        // maxDate={new Date()}
                        mode="portrait"
                        onChange={(e, date) => {
                          const records = {...account.records};
                          records[record.id].date = +date;
                          this.props.update({records});
                        }}
                        value={new Date(record.date)}
                      />
                    </TableRowColumn>
                    <TableRowColumn>
                      <TextField
                        // type="number"
                        name={`${record.id}-contribution`}
                        value={record.contribution}
                        onChange={(e, contribution) => {
                          const records = {...account.records};
                          records[record.id].contribution = contribution;
                          this.props.update({records});
                        }}
                      />
                    </TableRowColumn>
                    <TableRowColumn>
                      <TextField
                        // type="number"
                        name={`${record.id}-balance`}
                        value={record.balance}
                        onChange={(e, balance) => {
                          const records = {...account.records};
                          records[record.id].balance = balance;
                          this.props.update({records});
                        }}
                      />
                    </TableRowColumn>
                    <TableRowColumn>
                      <p>{record.total}</p>
                    </TableRowColumn>
                    <TableRowColumn>
                      <p>{Math.floor(record.returnAmount)} ({record.returnPercent}%)</p>
                    </TableRowColumn>
                    <TableRowColumn>
                      <IconButton
                        iconClassName="material-icons"
                        onTouchTap={() => {
                          const records = {...account.records};
                          delete records[record.id];
                          this.props.update({records});
                        }}
                      >
                        delete
                      </IconButton>
                    </TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        </HotKeys>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Account.js